import { Button } from '@mui/material';
import React from 'react'
import './scss/tab.component.scss'

export default function MultiTab(
    {
        data,
        activeIndexs,
        containerStyle,
        itemStyle,
        onClick
    }: {
        data: { title: string }[],
        activeIndexs: boolean[],
        containerStyle?: React.CSSProperties,
        itemStyle?: React.CSSProperties,
        onClick: (activeIndexs: boolean[], i: number) => void,
    }) {


    return (
        <div className='tab-component multi-tab-component'
            style={{ ...containerStyle }}
        >
            {
                data.map((e, i) => (
                    <Button
                        key={i}
                        color='primary'
                        variant={activeIndexs[i] ? 'contained' : 'text'}
                        onClick={() => {
                            const newArr: boolean[] = activeIndexs;
                            newArr[i] = !newArr[i];
                            onClick(newArr, i);
                        }}
                        style={{ minWidth: 100, ...itemStyle }}
                    >
                        {e.title}
                    </Button>
                ))
            }
        </div>
    )
}

